import { z } from "zod";

export const createInitialVehicleRestitutionPayload = z.object({
  cardHolderIdentification: z.string(),
  phone: z.string(),
  mileage: z.number(),
  isCabinCleaned: z.boolean(),
  isTrunkCleaned: z.boolean(),
  observations: z.string().nullable(),
  departureLocation: z.string(),
  furthestDestination: z.string(),
});

export type CreateInitialVehicleRestitutionPayload = z.infer<
  typeof createInitialVehicleRestitutionPayload
>;
